module.exports = __webpack_public_path__ + "static/media/GW.47fd8d67.svg";